import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { User } from 'model';
import { fetchLike as fetch } from '../api/baseQueryWithReauth.js';

export interface UserProfileState {
	user: User | null;
	fetching: boolean;
	errorMessage: string | null;
}

export const getUserById = createAsyncThunk('user/admin', async ({ id }: { id: string }): Promise<User> => {
	const response = await fetch('/api/users/get/' + id, {
		method: 'GET',
		cache: 'no-cache',
		headers: {
			'Content-Type': 'application/json'
		}
	});
	if (response.status === 200) {
		return await response.json();
	} else {
		let error = await response.json();
		if (!error) {
			error = response.statusText;
		}
		throw new Error(error);
	}
});

export const getUserProfile = createAsyncThunk('user/profle', async (): Promise<User> => {
	const response = await fetch('/api/users/profile/', {
		method: 'GET',
		cache: 'no-cache',
		headers: {
			'Content-Type': 'application/json'
		}
	});
	if (response.status === 200) {
		return await response.json();
	} else {
		let error = await response.json();
		if (!error) {
			error = response.statusText;
		}
		throw new Error(error);
	}
});

export const userProfileSlice = createSlice({
	name: 'userProfile',
	initialState: {
		user: null,
		fetching: false,
		errorMessage: ''
	} as UserProfileState,
	reducers: {
		setErrorMessage: (state, { payload }: { payload: string | null | undefined }) => {
			state.errorMessage = payload ?? '';
		},
		setFetching: (state, { payload }: { payload: boolean }) => {
			state.fetching = payload;
		}
	},
	extraReducers: builder => {
		// Add reducers for additional action types here, and handle loading state as needed
		builder.addCase(getUserById.fulfilled, (state, action) => {
			// Add user to the state array
			state.fetching = false;
			state.user = action.payload;
		});
		builder.addCase(getUserById.rejected, (state, action) => {
			state.fetching = false;
			state.errorMessage = action.error.message ?? '';
		});
		builder.addCase(getUserById.pending, state => {
			state.fetching = true;
		});
		builder.addCase(getUserProfile.fulfilled, (state, action) => {
			// Add user to the state array
			state.fetching = false;
			state.user = action.payload;
		});
		builder.addCase(getUserProfile.rejected, (state, action) => {
			state.fetching = false;
			state.errorMessage = action.error.message ?? '';
		});
		builder.addCase(getUserProfile.pending, state => {
			state.fetching = true;
		});
	}
});

// Action creators are generated for each case reducer function
export const { setFetching, setErrorMessage } = userProfileSlice.actions;
export default userProfileSlice.reducer;
